import React from "react";
import GreenUpArrow from "../../../assets/expand-menu.svg";
import { useNavigate } from "react-router-dom";

type Props = {
	menu: NavbarMenu;
	isSelected: boolean;
	isOpen: boolean;
	handleOpen: (openedTitle: string) => void;
};

const Menu = ({ menu, isSelected, isOpen, handleOpen }: Props) => {
	const navigate = useNavigate();
	const handleRedirect = (
		path: string,
		isDisabled?: boolean,
		isUrl?: boolean
	) => {
		if (isDisabled) {
			return;
		}
		if (isUrl) {
			location.href = path;
		} else {
			navigate(path);
			handleOpen("");
		}
	};
	return (
		<div
			className={`min-w-[4vw] flex justify-start items-center gap-0.2 cursor-pointer px-[1.2vh] py-[1vh] relative ${
				isSelected || isOpen
					? "border-b-[3px] border-deloitteGreen font-semibold text-deloitteGreen"
					: ""
			} `}
		>
			<div className="flex justify-between w-full">
				<p className="menu-title">{menu.title}</p>
				<img
					className={` arrow ml-2  ${isOpen ? "rotate-180" : ""}`}
					src={GreenUpArrow}
					alt="Dropdown"
				/>
			</div>
			<div className="z-[9999] hidden"></div>
			{isOpen && (
				<div className="absolute top-[100%] left-0 w-full translate-y-[3px] m-auto z-[10000] min-w-[20vh]">
					<ul>
						{menu.subMenus.map((subMenu) => (
							<li
								key={subMenu.name}
								className={`flex items-center p-[7px] border-[1px] bg-white justify-between ${
									subMenu.disabled
										? "cursor-not-allowed"
										: "cursor-pointer"
								}`}
								onClick={() =>
									handleRedirect(
										subMenu.route,
										subMenu.disabled,
										subMenu.isUrl
									)
								}
							>
								<span className="submenu-title min-w-[10vh]">
									{subMenu.name}
								</span>
								<img
									className="w-[0.8vw] rotate-[-90deg]"
									src={GreenUpArrow}
									alt="rightarrow"
								/>
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default Menu;
